module.exports = [
  { uri: '/shiritori/create', title: 'CREATE' },
  { uri: '/shiritori/join', title: 'JOIN' },
];
